import { conditionOperators, findConditionOperator } from "./operators/registry";
import { ConditionOperatorId, } from "./operators/types";
const NEGATION_PATTERN = /^!\s*(.*)$/;
export function parseConditionExpression({ expression, }) {
    const trimmed = expression.trim();
    const negation = trimmed.match(NEGATION_PATTERN);
    const body = negation ? negation[1].trim() : trimmed;
    for (const operator of conditionOperators) {
        const match = operator.parse({ expression: body });
        if (match)
            return { ...match, negated: Boolean(negation), recognized: true };
    }
    return {
        operatorId: ConditionOperatorId.Exists,
        path: trimmed,
        negated: false,
        recognized: false,
    };
}
export function buildConditionExpression({ match, negated, }) {
    const operator = findConditionOperator({ operatorId: match.operatorId });
    const body = operator ? operator.build({ match }) : match.path;
    return negated ? `!${body}` : body;
}
export function evaluateCondition({ condition, value, }) {
    const operator = findConditionOperator({ operatorId: condition.operatorId });
    if (!operator)
        return false;
    const result = operator.evaluate({ match: condition, value });
    return condition.negated ? !result : result;
}
export function evaluateConditionExpression({ expression, resolve, }) {
    const condition = parseConditionExpression({ expression });
    return evaluateCondition({ condition, value: resolve(condition.path) });
}
